var exports = {
  "W": "VoiceP2pConsentModal.module__points___MU1lVj",
  "m": "VoiceP2pConsentModal.module__checkboxLabel___MU1lVj",
};

module.exports = exports;
